import { Legend } from '@tremor/react';

type Props = {
    currentLabel?: string;
    comparisonLabel?: string;
};

export function ChartLegend({ currentLabel, comparisonLabel }: Props) {
    return (
        <div className="flex justify-end text-lg! font-normal">
            <Legend
                className="text-lg! font-normal [&_svg]:mr-cozy"
                categories={[comparisonLabel ?? 'Loading...', currentLabel ?? 'Loading...']}
                colors={['tremor-chart-secondary', 'tremor-chart-primary']}
            />
        </div>
    );
}
